import { render, staticRenderFns } from "./agentBindVx.vue?vue&type=template&id=020c42f2&"
import script from "./agentBindVx.vue?vue&type=script&lang=js&"
export * from "./agentBindVx.vue?vue&type=script&lang=js&"
import style0 from "./agentBindVx.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports